import React, { PropsWithChildren } from 'react';

import { StyledText } from './styles';
import { TextArgs } from './index';

export const Text = ({ children, opacityValue = 1, dataLocator, ...commonProps }: PropsWithChildren<TextArgs>) => {
  const { bold, type, color, mb, mt, uppercase, center, ellipsis, italic, underline, inline, medium, ...rest } =
    commonProps;
  const transparent = 1 - Number(opacityValue);

  return (
    <StyledText
      $opacityValue={transparent}
      data-locator={dataLocator}
      $bold={bold}
      $type={type}
      $color={color}
      $mb={mb}
      $mt={mt}
      $uppercase={uppercase}
      $center={center}
      $ellipsis={ellipsis}
      $italic={italic}
      $underline={underline}
      $inline={inline}
      $medium={medium}
      {...rest}
    >
      {children}
    </StyledText>
  );
};
